import React from 'react'

const RoleContext = React.createContext<{ roles?: { [key: string]: boolean } }>(
  {}
)

export default RoleContext
